import { styled } from '@mui/material/styles';

export const Root = styled('div')<{ isSmall: boolean; kioskMode: boolean }>(({ theme, isSmall, kioskMode }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  height: kioskMode ? '60px' : '50px',
  backgroundColor: theme.palette.common.white,

  '& button': {
    width: isSmall ? '50px' : '60px',
    padding: theme.spacing(1),
    cursor: 'pointer',
    border: 'none',
    fontSize: '1.5rem',
    height: '100%',
  },

  '& .decrease': {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
    backgroundColor: theme.palette.general.lightGrey5,
    borderRight: `1px solid ${theme.palette.primary.main}`,
  },

  '& .increase': {
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    backgroundColor: theme.palette.general.lightGrey5,
    borderLeft: `1px solid ${theme.palette.primary.main}`,
  },
}));
